<template>
    <performance-common-dialog
        :title="`发车单${title}页面`"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'350px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-width="100px"
                :model="form"
                :rules="rules"
            >
                <el-form-item label="设备类型：" prop="deviceType">
                    <el-select
                        v-model="form.deviceType"
                        :disabled="isEdit"
                        placeholder="设备类型"
                    >
                        <el-option
                            v-for="(val, key) in dictData.DEVICETYPE"
                            :key="key"
                            :label="val"
                            :value="key"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备号：" prop="deviceNo">
                    <el-input
                        v-model.trim="form.deviceNo"
                        placeholder="请输入设备号"
                        clearable
                        :disabled="isEdit"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="footer-bottom">
                <el-button
                    type="primary"
                    v-if="isEdit"
                    @click="editBtn"
                    :loading="loading"
                >
                    修 改
                </el-button>
                <el-button
                    type="primary"
                    v-if="!isEdit"
                    @click="bindBtn"
                    :loading="loading"
                >
                    绑 定
                </el-button>
                <el-button
                    type="primary"
                    v-if="isEdit"
                    @click="unbindBtn"
                    :loading="unbindLoading"
                >
                    解除绑定
                </el-button>
            </div>
        </template>
    </performance-common-dialog>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api.js';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import { saveupdatecancledevice } from '@/modules/transport/otp/api/dispatchOrderNew.js';
import { bindEquipment, cancelEquipment } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

export default {
    name: 'dispatchArrivalRegistration',
    components: { PerformanceCommonDialog },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            form: {
                deviceNo: '',
                deviceType: '10',
                dispatchDeviceOperateType: '',
                dispatchNo: ''
            },
            isEdit: false, // 是否可编辑
            dictData: {}, // 数据字典集合
            title: '设备绑定',
            loading: false,
            unbindLoading: false,
            rules: {
                deviceType: [
                    {
                        required: true,
                        message: '请选择设备类型',
                        trigger: ['blur', 'change']
                    }
                ],
                deviceNo: [
                    {
                        required: true,
                        message: '请输入设备号',
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    mounted () {
        this.initData(this.form, this.componentsData);
        this.$refs.performanceCommonDialog.show();
        this.getDicData();
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        },
        // 修改按钮
        editBtn () {
            this.isEdit = false;
        },
        // 绑定、修改
        bindBtn () {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.loading = true;
                    bindEquipment({
                        deviceNo: this.form.deviceNo,
                        deviceType: this.form.deviceType,
                        dispatchNo: this.componentsData.dispatchNo
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.data || '操作成功');
                            this.dialogClose();
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            });
        },
        // 解除绑定
        unbindBtn () {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.unbindLoading = true;
                    cancelEquipment({
                        deviceNo: this.form.deviceNo,
                        deviceType: this.form.deviceType,
                        dispatchNo: this.componentsData.dispatchNo
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.data || '操作成功');
                            this.dialogClose();
                        }
                    }).finally(() => {
                        this.unbindLoading = false;
                    });
                }
            });
        },
        /**
         * @saveupdatecancledevice 绑定或解绑接口
         * @param {Object} this.form 入参 dispatchNo发车单号、dispatchDeviceOperateType=0绑定,dispatchDeviceOperateType=1修改，dispatchDeviceOperateType=2解绑、deviceType设备类型、deviceNo设备编号
         */
        saveupdatecancledevice (dispatchDeviceOperateType) {
            this.form.dispatchDeviceOperateType = dispatchDeviceOperateType;
            saveupdatecancledevice(this.form).then(res => {
                if (res && +res.code === 0) {
                    this.loading = false;
                    this.$message.success('解绑成功');
                    this.$emit('components-close');
                }
            });
        },
        /**
        * @initData 页面初始化
        * @form 页面初始化数据
        * @componentsData 接收的行数据
        */
        initData (form, componentsData) {
            form.dispatchNo = componentsData.dispatchNo;
            // 根据设备绑定状态（0-已绑定，1-未绑定），绑定状态且设备号存在可进行取消、修改操作
            this.isEdit = !!(this.componentsData.bindingDeviceFlag === '0' && this.componentsData.deviceNo);
            if (this.isEdit) {
                this.isBind = false;
                this.title = '设备解绑/修改';
                form.deviceNo = componentsData.deviceNo;
                form.deviceType = componentsData.deviceType;
            }
        },
        /**
         * @description 获取数据字典
         * @param {string} 数据字典编码字符串
         * @return {Object} 数据字典类型集合
         */
        async getDicData () {
            const dict = await dictWithUrl(
                'DEVICETYPE'
            );
            this.dictData = dict.data;
        }
    }
};
</script>

<style scoped lang="less">
.footer-bottom {
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;
}
/deep/.el-select {
    width: 100%;
}
</style>
